const projectWhiteList = r => require.ensure([], () => r(require('@/page/projectWhiteList/projectWhiteList')), 'projectWhiteList');
const projectWhiteListView = r => require.ensure([], () => r(require('@/page/projectWhiteList/projectWhiteListView')), 'projectWhiteListView');
const projectWhiteListDetail = r => require.ensure([], () => r(require('@/page/projectWhiteList/projectWhiteListDetail')), 'projectWhiteListDetail');
const projectWhiteListStatistical = r => require.ensure([], () => r(require('@/page/projectWhiteList/projectWhiteListStatistical')), 'projectWhiteListStatistical');
const projectStatisticalTable = r => require.ensure([], () => r(require('@/page/projectWhiteList/statisticalTable/projectStatisticalTable')), 'projectStatisticalTable');

const projectWhiteListRouter = {
    path: '',
    name: '项目单位名录',
    component: projectWhiteList,
    meta: {
        right: [],
    },
    children: [
        {
            path: '/projectWhiteListView',
            component: projectWhiteListView,
            name: '项目单位名录',
            meta: {
                right: [],
                keepAlive: true,
            },
        },
        {
            path: '/projectWhiteListDetail',
            component: projectWhiteListDetail,
            name: '企事业单位名录',
            meta: {
                right: [],
            },
        },
        {
            path: '/projectWhiteListStatistical',
            component: projectWhiteListStatistical,
            name: '应急管理白名单',
            meta: {
                right: [],
            },
        },
        {
            path: '/projectStatisticalTable',
            component: projectStatisticalTable,
            name: '物业项目列表',
            meta: {
                right: [],
            },
        },
    ]
};
export default projectWhiteListRouter;